export const PathConstants = {
    Home: "/",
    Contracts: "/contracts",
    Contract_templates:"/contract_templates",
    Users: "/users",
    Business: "/business",
    ContractDetails: "/contracts/:contractId",
    DocumentDetails: "/contracts/:contractId/documents/:documentId",
    Signup: "https://app.verifech.online/",
    Login:"https://app.verifech.online/",
    OrgVerification: "/organizations/:orgId/verify/:invitationId",
    UserVerification: "/users/:orgId/verify/:invitationId",
    Dashboard: "/dashboard"
}
